import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { MENUITEM_IDS } from '@/lib';
import { EmailEditorForm } from '@/features/email-flows/emails/components';
import { EmailEditorLayout } from '@/features/email-flows/components/layout/EmailEditorLayout';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { useStanRouter } from '@/hooks/useStanRouter';

const EditEmailPage: FC = () => {
    const { flowId, emailId } = useParams<{ flowId: string; emailId: string }>();
    const { push } = useStanRouter();

    // Parse and validate flowId and emailId
    const parsedFlowId = Number(flowId) || -1;
    const parsedEmailId = Number(emailId) || -1;

    useEffect(() => {
        if (parsedFlowId === -1 || parsedEmailId === -1) {
            push('/flows');
        }
    }, [parsedFlowId, parsedEmailId, push]);

    useBreadcrumbs([
        { title: 'My Email Flows', to: '/flows', id: MENUITEM_IDS.FLOWS, active: false },
        { title: 'Flows', to: `/flows?tab=flows`, id: 'flows-tab', active: false },
        { title: 'Edit Email', to: `/flows/${flowId}/emails/`, id: 'edit-email', active: true },
    ]);

    // Don't render if IDs are invalid
    if (parsedFlowId === -1 || parsedEmailId === -1) {
        return null;
    }

    return (
        <EmailEditorLayout flowId={parsedFlowId} emailId={parsedEmailId}>
            <EmailEditorForm flowId={parsedFlowId} emailId={parsedEmailId} />
        </EmailEditorLayout>
    );
};

export default EditEmailPage;
